// @noflow
import 'babel-polyfill';
import { ENVIRONMENT_CONFIG } from '~/core/state/config/constants';
import { initializePolyfills } from './polyfills';
import { noop, identity, pickBy } from 'lodash/fp';
import Raven from 'raven-js';
import ReactGA from 'react-ga';

// We config raven/sentry before nearly everything to allow us to catch as many error
// as possible.
if (ENVIRONMENT_CONFIG.sentryDSN) {
    // '----' is the default value injected by our CRA fork when build number is unknown
    const buildNumber = process.env.BUILD_NUMBER;
    const sentryConfig = pickBy(identity, {
        release: buildNumber && buildNumber !== '----' && buildNumber,
        environment: ENVIRONMENT_CONFIG.environment
    });

    Raven.config(ENVIRONMENT_CONFIG.sentryDSN, sentryConfig).install();
}

// If UATrackingID is undefined then there will only be a console warning
ReactGA.initialize(ENVIRONMENT_CONFIG.UATrackingID);

initializePolyfills()
    .then(
        // load up all possible timezone locales we might use ahead of time
        () => {
            return Promise.all(
                process.locales.map(l => {
                    const [country] = l.split('-');
                    return Promise.all([
                        import(`moment/locale/${l}`).catch(noop),
                        import(`moment/locale/${country}`).catch(noop)
                    ]);
                })
            );
        }
    )
    .then(
        () => {
            // Using `require` statements here instead of `import` lets us
            // carefully control the order and timing of what code is ran.
            //
            // We want to make sure all polyfills happen before we start
            // running the code in the rest of the app otherwise we may
            // get errors from code that depends on one of the polyfills
            // being present.

            require('./app').run();
        },
        err => {
            // We will need to consider what to do here - ask to refresh? check network?

            console.error(`There was an error polyfilling features. ${err.message}`);
        }
    );



// WEBPACK FOOTER //
// ./src/index.js